// extracted by mini-css-extract-plugin
module.exports = {"buttonArrow":"ButtonArrow_buttonArrow__2IXuE","left":"ButtonArrow_left__uQoi8","right":"ButtonArrow_right__2te5n"};